import React from "react";

interface Props {
  children?: React.ReactNode;
  className?: string;
  htmlFor?: string;
  title?: string | React.ReactNode;
}

const Label: React.FC<Props> = ({
  children,
  className = "text-[#505050] font-normal",
  htmlFor,
  title,
}) => {
  return (
    <>
      <label className={className} htmlFor={htmlFor}>
        {title}
      </label>
      {children}
    </>
  );
};

export default Label;
